module.exports = __webpack_public_path__ + "static/img/9.a66f7a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/zh/9.png
// module id = /I1s
// module chunks = 0